import type { CotacaoReferenciaItem } from "@/modules/financeiro-configuracoes";
import {
  MOEDAS_TAG_FUTURA,
  MOEDAS_TAG_INATIVA,
  MOEDAS_TAG_REFERENCIA_ATUAL,
} from "./moedas.constants";
import type { MoedaTag } from "./types-moedas";

const COTACAO_FORMATTER = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const CADASTRADA_EM_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const CADASTRADA_DATA_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  timeZone: "America/Sao_Paulo",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function formatCompetencia(competencia: string): string {
  const [ano, mes] = competencia.split("-");
  return `${mes}/${ano}`;
}

export const formatCotacao = (cotacao: number): string => COTACAO_FORMATTER.format(cotacao);

export function formatCadastradaEm(instante: string): string {
  const data = new Date(instante);
  return Number.isNaN(data.getTime())
    ? instante
    : CADASTRADA_EM_FORMATTER.format(data).replace(",", "");
}

export function formatCadastradaData(instante: string): string {
  const data = new Date(instante);
  return Number.isNaN(data.getTime()) ? instante : CADASTRADA_DATA_FORMATTER.format(data);
}

export function tagsDaCotacao(item: CotacaoReferenciaItem, mesAtual: string): MoedaTag[] {
  const tags: MoedaTag[] = [];
  if (item.referenciaAtual) tags.push({ rotulo: MOEDAS_TAG_REFERENCIA_ATUAL, tom: "info" });
  if (item.competencia > mesAtual) tags.push({ rotulo: MOEDAS_TAG_FUTURA, tom: "warning" });
  if (item.situacao === "INATIVA") tags.push({ rotulo: MOEDAS_TAG_INATIVA, tom: "secondary" });
  return tags;
}
